const ACCESS_TOKEN = 'MTX_ACCESS_TOKEN'
const IS_FIRST_AUTH = 'is-first-auth'

export {
  ACCESS_TOKEN,
  IS_FIRST_AUTH
}
